export default __webpack_public_path__ + "static/media/img5.31285b12.png";